import { SearchAlertCaseConstant } from "../redux_constants/search.case.constant";
import { loadCases, loadCaseStatus, loadUsers } from "./cases.action";
import {getNewStatePreserveOrdering} from "../redux_reducers/search.case.reducer";
import {caseReadStatusEnum} from "../utils/const";
import {isTrue} from "../utils/utils";

export const searchInitiated = () => ({
    type: SearchAlertCaseConstant.CASE_SEARCH_INITIATED
})

export const searchSuccess = () => ({
    type: SearchAlertCaseConstant.CASE_SEARCH_SUCCESS
})

export const searchFailed = (error) => ({
    type: SearchAlertCaseConstant.CASE_SEARCH_FAILED,
    response: error
})

export const applyCaseFilters = (currentState, page, case_assigned, read_status, date__gte, date__lte, priority, case_status, archive_status) => dispatch => {
    dispatch(loadCases({
        ...currentState,
        page,
        case_assigned,
        read_status,
        date__gte,
        date__lte,
        priority,
        case_status,
        archive_status
    }))
}

export const clearAllFilters = () => dispatch => {
    setTimeout(() => dispatch(loadCases(getNewStatePreserveOrdering())), 100);
}

export const getAssignedCases = (currentState) => dispatch => {
    dispatch(loadCases({
        ...currentState,
        case_assigned: true,
        page: 1
    }))
}

export const getUnreadCases = (currentState) => dispatch => {
    dispatch(loadCases({
        ...currentState,
        read_status: caseReadStatusEnum.UNREAD,
        page: 1
    }))
}

export const getReadCases = (currentState) => dispatch => {
    dispatch(loadCases({
        ...currentState,
        read_status: caseReadStatusEnum.READ,
        page: 1
    }))
}

export const getAll = (currentState) => dispatch => {
    dispatch(loadCases({
        ...currentState,
        case_assigned: false,
        read_status: caseReadStatusEnum.ALL,
        page: 1
    }))
}

export const changePage = (pageNumber, currentState) => dispatch => {
    dispatch(loadCases({
        ...currentState, 
        page: pageNumber
    }))
}

export const updateCaseSearch = (value, currentState) => dispatch => {
    var newState = {
        ...currentState,
        search: value, 
        page: 1
    }
    dispatch(loadCases(newState));
}

export const setDateRange = (newDateGte, newDateLte, currentState) => dispatch => {
    dispatch(loadCases({
        ...currentState,
        date__gte: newDateGte,
        date__lte: newDateLte,
        page: 1
    }));
}

export const changeOrdering = (newOrdering, currentState, isUnreadTableCollapsed=false) => dispatch => {
    dispatch(loadCases({
        ...currentState,
        ordering: newOrdering,
    },true,isUnreadTableCollapsed));
}

export const updateUrlStateInReducer = (oldState, skipParser=false) => dispatch => {
    const newState = skipParser ? oldState : urlParser(oldState);
    dispatch(loadCases(newState));
    dispatch(loadCaseStatus());
    dispatch(loadUsers());
}

export const updateUrlStateInReducerClia = (oldState, type) => dispatch => {
    const newState = urlParserClia(oldState, type);
    dispatch(loadCases(newState));
    dispatch(loadCaseStatus());
    dispatch(loadUsers());
}

export const urlParserClia = (parsedPartsOfUrl, type) => {
    try{
        const validation_strings =  window.location.href.split('?')[0].split('/');
        const validation_id = validation_strings[validation_strings.length - 1];
        parsedPartsOfUrl = urlParser(parsedPartsOfUrl);
        parsedPartsOfUrl.archive_status = '';
        parsedPartsOfUrl.validation_id = validation_id;
        parsedPartsOfUrl.type = type;
    }catch(err){
        console.log('Could not parse Url : ' + err.message);
    }
    return parsedPartsOfUrl;
}

export const urlParser = (parsedPartsOfUrl) => {
    try {
        const url = window.location.href.split('?')[1];
        var partsOfUrl = url.split('&');
        partsOfUrl.forEach((part) => {
            var key = part.split('=')[0];
            var value = part.split('=')[1];
            if (key === 'search') {
                if (value.length > 0) parsedPartsOfUrl.search = decodeURIComponent(value);
            } else if (key === 'case_assigned') {
                parsedPartsOfUrl.case_assigned = isTrue(value);
            } else if (key === 'read_status') {
                parsedPartsOfUrl.read_status = value;
            } else if (key === 'page') {
                parsedPartsOfUrl.page = parseInt(value);
            } else if (key === 'date__gte') {
                parsedPartsOfUrl.date__gte = value;
            } else if (key === 'date__lte') {
                parsedPartsOfUrl.date__lte = value;
            } else if (key === 'ordering') {
                parsedPartsOfUrl.ordering = value;
            } else if (key === 'priority' && value !== '') {
                parsedPartsOfUrl.priority = parseInt(value);
            } else if (key === 'case_status' && value !== '') {
                parsedPartsOfUrl.case_status = parseInt(value);
            } else if (key === 'archive_status') {
                parsedPartsOfUrl.archive_status = value;
            }
        });
    } catch (err) {
        console.log('Could not parse Url : ', err);
    }
    return parsedPartsOfUrl;
}
